import React from 'react';
import Card from '../../../../components/Card/Card';

import './HelpCard.css';

type HelpCardProps = {
  title: string;
  description: string;
  onClick: () => void;
};

export const HelpCard: React.FC<HelpCardProps> = ({
  description,
  onClick,
  title,
}) => {
  return (
    <div className="clickable" role="button" onClick={onClick}>
      <Card>
        <h3 className="help--card-title help--card-content">{title}</h3>
        <p className="paragraph help--card-content">{description}</p>
      </Card>
    </div>
  );
};
